/*
  Platzierung des KI-Tooltips.

  Der Tooltip ist position: fixed, weil mehrere Container im Theme mit
  overflow: hidden clippen — die Suchvorschau, die Empfehlungszeilen und
  die Wunschlisten-Karte (dort sogar mit !important). Aus dem Sichtfenster
  heraus positioniert entkommt er ihnen allen; dafuer muessen die
  Koordinaten hier gesetzt werden.

  Event-Delegation, weil Suchvorschau, Warenkorb und Wunschliste ihre
  Inhalte nachladen.
*/
(function () {
  var RAND = 12;
  var ABSTAND = 9;

  function richte(badge) {
    var tip = badge.querySelector('.ki-bild-tip');
    if (!tip) return;

    var b = badge.getBoundingClientRect();
    var breite = tip.offsetWidth;
    var hoehe = tip.offsetHeight;

    // Senkrecht: nach oben, wenn der Tooltip dort ins Sichtfenster passt.
    var oben = b.top - hoehe - ABSTAND >= RAND;
    tip.style.top = (oben ? b.top - hoehe - ABSTAND : b.bottom + ABSTAND) + 'px';
    badge.classList.toggle('ki-bild-winzig--oben', oben);

    // Waagerecht: am Kuerzel ausrichten, aber im Sichtfenster halten.
    var maxLinks = Math.max(RAND, window.innerWidth - RAND - breite);
    var links = Math.min(Math.max(b.left - 4, RAND), maxLinks);
    tip.style.left = links + 'px';

    // Die Spitze zeigt auf das Kuerzel, bleibt aber an der Box.
    var mitte = b.left + b.width / 2 - links;
    var pfeil = Math.min(Math.max(mitte, 12), Math.max(12, breite - 12));
    tip.style.setProperty('--ki-tip-pfeil', pfeil + 'px');
  }

  ['mouseover', 'focusin'].forEach(function (typ) {
    document.addEventListener(
      typ,
      function (e) {
        var badge = e.target.closest && e.target.closest('.ki-bild-winzig, .ki-bild-badge--modal');
        if (badge) richte(badge);
      },
      true,
    );
  });
})();
